import { SubMenu } from '../../../components/SubMenu/SubMenu'
import { Navigation } from '../components/Navigation'

export default function Index() {
  return <SubMenu leftContent={<Navigation />} />
}
